import { render, staticRenderFns } from "./AlertSuccess.vue?vue&type=template&id=596bcbb4"
import script from "./AlertSuccess.vue?vue&type=script&lang=js"
export * from "./AlertSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports